import Item from './Item';
import HelpText from './HelpText';
import NoResults from './NoResults';

const Items = ({focus, suggestions, onSelect}) => {
    if (suggestions) {
        if (suggestions.length === 0) return <NoResults />;

        return suggestions.map((suggestion, index) => (
            <Item
                {...suggestion}
                key={suggestion.id}
                focus={focus === index}
                onSelect={onSelect}
            />
        ));
    }

    if (focus) return <HelpText />;

    return null;
};

const DataList = props => (
    <ul id="location-search-suggestions" className="search-suggestions-list">
        <Items {...props} />
    </ul>
);

export default DataList;
